import {
    Calendar,
    Clock,
    Insurance,
    MedicalTeam,
    Settings,
    Signout,
    WellGuide,
    Zee,
} from '@zocdoc-frontend-common/assets-icons';
import { DropdownLinks } from '@zocdoc-frontend-common/utils-constants/HeaderLinks';

const MobilePatientLinks = (usePatientHomeView) => {
    const links = [
        {
            message: 'My Zocdoc',
            url: DropdownLinks.medicalTeam,
            icon: (props) =>
                Zee({ expression: Zee.expression.smile, ...props }),
            dataTest: 'my-zocdoc',
        },
        {
            message: usePatientHomeView ? 'My Zocdoc' : 'My doctors',
            url: usePatientHomeView
                ? DropdownLinks.medicalTeam
                : DropdownLinks.myDoctors,
            icon: MedicalTeam,
            dataTest: usePatientHomeView ? 'medical-team' : 'my-doctors',
        },
        {
            message: 'Well guide',
            url: DropdownLinks.myWellGuide,
            icon: WellGuide,
            dataTest: 'well-guide',
        },
        {
            message: 'Upcoming appointments',
            url: DropdownLinks.upcomingAppointments,
            icon: Clock,
            dataTest: 'upcoming-appointments',
        },
        {
            message: 'Appointment history',
            url: DropdownLinks.appointmentHistory,
            icon: Calendar,
            dataTest: 'appointment-history',
        },
        {
            message: 'Insurance',
            url: DropdownLinks.insurance,
            icon: Insurance,
            dataTest: 'insurance',
        },
        {
            message: 'Settings',
            url: DropdownLinks.settings,
            icon: Settings,
            dataTest: 'settings',
        },
        {
            message: 'Sign out',
            url: DropdownLinks.signout,
            icon: Signout,
            dataTest: 'sign-out',
        },
    ];

    return links;
};

const ProviderLinks = [
    {
        message: 'Calendar',
        url: DropdownLinks.providerCalendar,
        dataTest: 'provider-calendar',
        metrics: {
            action: 'Click PageHeader Username Dropdown Calendar',
            element: 'Calendar',
        },
    },
    {
        message: 'Help',
        url: DropdownLinks.providerHelp,
        dataTest: 'provider-help',
        metrics: {
            action: 'Click PageHeader Username Dropdown Help',
            element: 'Help',
        },
    },
    {
        message: 'Sign out',
        url: DropdownLinks.signout,
        dataTest: 'sign-out',
        metrics: {
            action: 'Click PageHeader Username Dropdown SignOut',
            element: 'SignOut',
        },
    },
];

const ZdEmployeeLinks = [
    {
        message: 'Zocdoc Pulse',
        url: DropdownLinks.pulse,
        dataTest: 'pulse',
    },
    {
        message: 'Sign out',
        url: DropdownLinks.signout,
        dataTest: 'sign-out',
    },
];

export const MobileUserLinks = (
    usePatientHomeView,
    shouldHideUpcomingApptsLink
) => ({
    Patient: shouldHideUpcomingApptsLink
        ? MobilePatientLinks(usePatientHomeView).filter((l) => {
              return !l.message.includes('Upcoming appointments');
          })
        : MobilePatientLinks(usePatientHomeView),
    Provider: ProviderLinks,
    ZdEmployee: ZdEmployeeLinks,
});

export const TRACKING_ELEMENTS = {
    patientCollapsibleLogin: 'PatientCollapsibleLogin',
    patientLogin: 'PatientLogin',
    patientSignup: 'PatientSignup',
    providerLogin: 'ProviderLogin',
};

export const GA_ACTION_TEXT = {
    clickCloseCollapsibleLogin: 'Click Close Patient Collapsible Login',
    clickOpenCollapsibleLogin: 'Click Open Patient Collapsible Login',
    clickPatientLoginLink: 'Click Patient Login Link',
    clickPatientSignupLink: 'Click Patient Signup Link',
    clickProviderLoginLink: 'Click Provider Login Link',
    showPatientSplitLoginAndSignup: 'Show Patient Split Login And Signup',
    showPatientDefaultLoginAndSignup: 'Show Patient Default Login And Signup',
    showPatientMfaVerificationForm: 'Show Patient MFA Verification Form',
};
